import { lazy } from 'react';

const FeatureUpsellModal = lazy(
  () => import('modules/FeaturePaywall/modals/UpsellModal'),
);

export default {
  FEATURE_UPSELL_MODAL: FeatureUpsellModal,
};
